module.exports = __webpack_public_path__ + "assets/img/组 146@2x.c44d4f2c.png";